import { render, staticRenderFns } from "./SpecializationsPicker.vue?vue&type=template&id=b2cf82b4&"
import script from "./SpecializationsPicker.vue?vue&type=script&lang=js&"
export * from "./SpecializationsPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports